export default __webpack_public_path__ + "static/io-e31ca9aa9209d9b76a0b7511c21e9fc0.svg";